import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { AskState } from './community-ask.reducer';

// Selector to get the "ask" state from the AppState
export const selectAskState = (state: AppState) => state.ask;

// Selector to get all community ask data
export const selectAllCommunityAsk = createSelector(
  selectAskState,
  (state: AskState) => state.ask
);

// Selector to get the loading state
export const selectLoading = createSelector(
  selectAskState,
  (state: AskState) => state.loading
);
